import React from 'react'
import * as playerActions from 'context/player/reducer/player.actions'
import { Duration } from 'luxon'
import {
  Container,
  InfoContainer,
  Div,
  BookTitle,
  BookThumb,
  CurrentTimeStap,
  TimeLoading,
  ControlsContainer,
  ProgressBar,
  CommandButton
} from './PlayerBarMinified.styles'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { usePlayerContext } from 'context/player'

const PlayerBarMinified: React.FC = () => {
  const {
    dispatch,
    state: {
      name,
      imageUrlThumb,
      currentTrackTime,
      loading,
      isPlaying,
      progressBar
    }
  } = usePlayerContext()

  return (
    <Container data-testid="mobile-player">
      <InfoContainer
        data-testid={'content-info'}
        onClick={() => dispatch(playerActions.open())}
      >
        <Div>
          <BookThumb src={imageUrlThumb} />
          <BookTitle>{name}</BookTitle>
        </Div>
        {loading && (
          <TimeLoading data-testid="loading-timer">--:--</TimeLoading>
        )}
        {!loading && (
          <CurrentTimeStap data-testid="current-timer">
            {Duration.fromMillis(currentTrackTime * 1000).toFormat(
              currentTrackTime >= 3600 ? 'hh:mm:ss' : 'mm:ss'
            )}
          </CurrentTimeStap>
        )}
      </InfoContainer>
      <ControlsContainer>
        <CommandButton
          data-testid="play-pause"
          iconName={isPlaying ? 'pause' : 'play'}
          iconColor={tokens.colors.primary}
          disabled={loading}
          onClick={
            isPlaying
              ? () => dispatch(playerActions.pause())
              : () => dispatch(playerActions.play())
          }
        />
        <CommandButton
          data-testid="close"
          iconName={'cancel'}
          iconColor={tokens.colors.black4}
          onClick={() => dispatch(playerActions.close())}
        />
      </ControlsContainer>
      <ProgressBar data-testid="player-progress-bar" value={progressBar} />
    </Container>
  )
}

export default PlayerBarMinified
